import { useTranslation } from 'react-i18next'

const BorderPoliceEnd = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="borderpolice-end-title"
      {...props}
    >
      <title id="borderpolice-end-title">{t('antagonists:borderpolice:components:end')}</title>
      <defs>
        <clipPath id="borderpolice-end-b">
          <path
            d="M1505.95 273.69s21.21-25.83 65.19-25.77c44 .06 56.4 19.53 56.4 19.53s-.77-35.69-11.61-51.48c-10.83-15.78-44.46-29.33-54.18-30.42-9.72-1.08-40.27 23.9-46.83 32.5-6.57 8.62-10.83 53.27-8.98 55.62Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.c,.d{fill:none}.e{fill:#b98743}.f{fill:#c48648}.g{fill:#c4c7c9}.h{fill:#b39746}.i{fill:#235a96}.j{fill:#222d44}.k{fill:#9b4632}.l{fill:#31405d}.m{fill:#2f2b39}.n{clip-path:url(#borderpolice-end-b)}.d{stroke:#b39746;stroke-linejoin:round;stroke-width:1.59px}'
          }
        </style>
      </defs>
      <path
        d="M1506.01 271.05s-11.58 14.1-7.37 34.1c2.2 10.48 12.85 23.06 18.43 29.07 14.27 15.4 63.44 18.59 76.56 18.29 13.12-.3 30.26-22.93 34.36-30.48 4.1-7.55 14.22-29.68 7.86-40.18-6.36-10.49-7.59-11.32-9.84-22.2-2.26-10.88-30.15-43.26-59.28-42.47s-54.98 37.52-60.72 53.85Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        d="M1529.73 315.74s5.33 30.57 3.89 43.05c-.64 5.6.46 8.19-20.52 21.3-15.95 9.96-48.27 35.23-48.27 35.23l101.78 27.39 109.82-58.12s-32.77-11.92-52.46-18.95c-12.69-4.53-12.59-18.96-12.41-26.47.42-16.18 1.03-30.51 1.03-30.51l-82.86 7.1v-.03Z"
        style={{
          fill: '#b98743',
        }}
      />
      <path
        d="M1469.99 678.02s-21.61 175.34-1.96 250.01c19.63 74.69 25.53 115.91 30.43 148.31 4.9 32.4 2.51 45.99 5.59 86.24 2.51 32.89 24.22 63.28 26.18 72.12s10.55 35 10.55 35l62.65-8.04s20.7-16.6 12.85-63.74c-7.86-47.14-20.63-124.69-23.57-164.92-2.94-40.23-3.92-120.64 0-195.12s-2.94-172.6-2.94-172.6l-119.79 12.74Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        d="M1458.34 903.87s-10.83 43.39-1.28 66.84c9.56 23.45 24.56 43.56 24.56 43.56l22.91-1.72-15.2-103.25-31-5.41ZM1456.39 868.37l-4.38 33.09 39.15 4.62.48-33.37-35.25-4.34z"
        style={{
          fill: '#222d44',
        }}
      />
      <path
        d="M1704.86 670.87s39.32 172.74 27.36 248.76c-11.96 76.03-13.64 117.58-15.23 150.25s11.38 63.01 1.77 94.47c-9.61 31.46-23.63 68.24-24.68 77.2-1.06 8.98-3.58 20.15-3.58 20.15l-62-1.83s-19.51-11.34-16.48-58.94c3.03-47.6 7.86-125.91 6.7-166.21s-18.55-115.21-30.03-189.05c-11.47-73.83-4.4-177.33-4.4-177.33l120.56 2.51h.01Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        d="M1739.3 895.86s6.49 41.48-.62 65.62c-7.13 24.15-11 37.48-11 37.48l-23.21 7.91 7.71-105.43 27.14-5.59h-.01ZM1738.65 859.73l6.82 32.1-38.52 7.92-3.86-33.2 35.56-6.82z"
        style={{
          fill: '#222d44',
        }}
      />
      <path
        d="M1416.34 822.86s18.86 27.79 22.2 37.27c3.34 9.48 41.7 21.06 41.94 20.64s19.41 6.6 19.41 6.6 3.72-9.94-2.29-14.76c-6-4.83-16.79-2.29-23.45-13.39-6.66-11.09-13.45-23.94-9.38-26.09 4.07-2.15 15.59 25.14 19.99 26.82s10.95.64 10.95.64-6-15.2-7.33-21.28c-1.32-6.08-13.08-22.6-18.93-28.19s-12.19-10.33-16.66-17.36c-4.46-7.03-11.65-22.63-11.65-22.63l-37.24 27.51s8.57 10.22 12.45 24.21h-.01ZM1734.62 798.73s-8.43 31.95-9.12 41.97c-.7 10.02-36.88 30.55-37.24 30.2s-16.96 11.26-16.96 11.26-6.23-8.69-1.72-14.88c4.5-6.18 15.57-6.43 19.02-18.84 3.46-12.41 6.57-26.54 2.08-27.63-4.49-1.08-8.31 28.26-12.11 31-3.8 2.73-10.37 3.37-10.37 3.37s1.72-16.23 1.38-22.44c-.34-6.23 6.57-25.16 10.73-32.04 4.15-6.88 8.99-13.05 11.41-20.98 2.42-7.92 5.19-24.83 5.19-24.83l43.24 17.28s-5.53 12.05-5.53 26.56Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1520.78 252.71s4.24 29.75-1.43 50.32c-2.62 9.5-1.06 33.84 19.69 47.48 20.85 13.72 30.52 16.2 36.68 15.43s18.9-8.41 27.52-14.28c8.62-5.87 20.08-32.4 18-43.08-2.44-12.51-7.28-36.74-8.71-42.68-1.44-5.94-6.82-24.42-6.82-24.42l-39.59-2.59-45.34 13.82Z"
        style={{
          fill: '#b98743',
        }}
      />
      <path
        d="M1524.27 284.63s-13.54-7.49-18.87-1.38c-3.09 3.54 1.83 14.89 4.81 24.1 2.17 6.7 3.63 13.37 5.26 14.77 3.89 3.31 4.68-1.47 7.56-2.88 2.87-1.41 7.18-2.81 7.18-2.81l-5.94-31.8ZM1613.5 286.19s10.67-6.06 16.2-2.73c5.54 3.33-3.89 16.35-4.92 23.11-1.03 6.76.61 11.47-4.92 13.27-5.54 1.8-11.49-.71-11.49-.71l5.13-32.93Z"
        style={{
          fill: '#b98743',
        }}
      />
      <path
        d="M1505.95 273.69s21.21-25.83 65.19-25.77c44 .06 56.4 19.53 56.4 19.53s-.77-35.69-11.61-51.48c-10.83-15.78-44.46-29.33-54.18-30.42-9.72-1.08-40.27 23.9-46.83 32.5-6.57 8.62-10.83 53.27-8.98 55.62Z"
        style={{
          fill: '#31405d',
        }}
      />
      <g
        style={{
          clipPath: 'url(#borderpolice-end-b)',
        }}
      >
        <path
          d="M1559.27 197.24s-8.37 4.16-7.95 7.4 2.85 3.39 2.85 3.39-4.5 1.98-4.07 7.09c.43 5.11 4.07 12.27 7.65 14.06 3.57 1.78 5.5-1.03 5.5-1.03s2.85 2.45 6.11-.76c3.27-3.19 4.15-10.33 3.72-14.91s-6.08-5.84-6.08-5.84 1.56-2.14.8-4.43-8.53-4.99-8.53-4.99Z"
          style={{
            fill: '#b39746',
          }}
        />
        <path
          d="M1554.2 210.72s2.42-2.13 6.45-2.36c4.04-.24 6.49.73 6.49.73s2.33 15.6-4.56 15.43c-7.95-.21-8.38-13.81-8.38-13.81Z"
          style={{
            fill: '#235a96',
          }}
        />
        <path
          d="m1517.35 208.77 13.21-.68s-7.1 15.43 3.15 18.52c10.66 3.21 17.91-.3 30.49-.86 12.6-.56 28.96-.13 31.74-6.17 4.25-9.27-5.41-17.22-5.41-17.22l13.09-3.43"
          style={{
            fill: 'none',
            stroke: '#b39746',
            strokeLinejoin: 'round',
            strokeWidth: '1.59px',
          }}
        />
      </g>
      <path
        d="M1551.19 331.37c-.62 4.34 2.36 8.53 6.82 9.91 4.96 1.55 6.76 2.85 12.51 2.9 11.28.09 15.44-7.09 16.93-8.17 3.4-2.48 6.2-4.34 5.26-7.43-.82-2.72-10.39-4.34-14.49-4.16s-4.92 2.42-6.57 2.41c-1.63 0-8.49-3.77-12.99-2.38-4.52 1.4-6.75 1.84-7.47 6.92Z"
        style={{
          fill: '#9b4632',
        }}
      />
      <path
        d="M1554.75 267.13s-5.99-1.28-12.62-1.69c-6.73-.42-13.4 4.47-13.49 4.55s-1.99-2.99-1.99-2.99 9.51-7.45 17.62-7.49 12.97 2.9 12.97 2.9l-2.51 4.73h.01ZM1544.33 283.16l-8.01 2.3-1.03-2.67 9.33-4.21s-.04 4.53-.3 4.58Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        style={{
          fill: '#2f2b39',
        }}
        d="m1546.77 279.86-12.23-.19-.41-2.97 12.75-.15-.11 3.31z"
      />
      <path
        d="M1543.86 275.4c-2.48 1.78-3.02 4.7-1.16 7.06s4.8 2.39 7.13.94c2.75-1.71 2.59-4.61.92-7.22-1.17-1.84-4.34-2.6-6.9-.77Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        d="M1531.99 365.21s.65 14.33 14.85 24.45c14.19 10.12 29.22 16.08 29.22 16.08s19.47-8.95 29.04-17.22c13.98-12.11 14.34-27.12 14.34-27.12s20.89 9.04 43.44 15.89c22.54 6.85 53.01 20.94 59.69 36.82 6.67 15.89-9.61 118.63-7.1 177 2.51 58.37 20.03 123.53 20.03 123.53l-268.71 17.15s-22.62-39.56-10.94-107.81-34.37-188.49-17.06-203.65c14.62-12.81 46.5-25.56 63.13-35.81 16.79-10.34 30.08-19.3 30.08-19.3Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        d="M1547.83 532.65s2.38 44.54 3.33 55.01c.95 10.46-2.85 16.14-20 18.86-17.13 2.7-37.24 6.61-48.67 3.67-11.43-2.94-10.45-14.91-11.59-31.07-1.14-16.18 0-31.83 0-31.83l76.92-14.62h.01ZM1466.91 512.1l78.52-9.11s6.67 20.02.95 24.73c-5.71 4.71-71.2 16.05-74.82 11.61-5.97-7.34-4.65-27.22-4.65-27.22ZM1464.12 717.52l-3.05 41.64s64.15 19.23 124.56 19.73c60.42.51 141.06-12.69 141.06-12.69l-9.48-43.1s-61.15 9.79-118.63 10.06c-57.47.27-135.2-17.12-134.47-15.65h.01Z"
        style={{
          fill: '#222d44',
        }}
      />
      <path
        d="M1705.08 397.63c41.7 11.41 54.66 187.7 63.04 232.88 8.08 43.53.61 70.63-8.29 94.78-8.9 24.15-19.2 64.08-19.2 64.08l-6.15 16.2-57.72-14.31s9.7-24.15 7.28-85.54c-2.42-61.39.8-71.87-8.9-98.6-9.7-26.73-39.62-103.7-40.44-130.36-.8-26.66 38.01-88.02 70.39-79.16l-.02.03Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        style={{
          fill: '#222d44',
        }}
        d="m1609.23 492.1-.48 26.06 75.81 5.96-.11-27.59-75.22-4.43z"
      />
      <path
        style={{
          fill: '#b39746',
        }}
        d="m1615.68 498.58-.89 13.09 62.92 4.09.29-12.5-62.32-4.68z"
      />
      <path
        d="M1523.81 817.86c-1.14 7.83-6.15 14.7-18.53 13.08-11.65-1.53-13.64-11.2-13.15-17.16.48-5.96 6.17-14.28 16.14-13.84 11.49.51 16.67 10.21 15.54 17.92Zm-15.65-12.01c-6.2-.28-9.73 4.89-10.03 8.6-.3 3.7.94 9.72 8.17 10.67 7.7 1.01 10.82-3.25 11.52-8.13.7-4.79-2.53-10.82-9.66-11.13Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        style={{
          fill: '#c4c7c9',
        }}
        d="m1504.81 777.2-1.42 25.59 11.6 1.14 1.05-24.53-11.23-2.2z"
      />
      <path
        style={{
          fill: '#222d44',
        }}
        d="m1498.86 717.56-7.35 73.58 34.75 3.93 4.48-74.61-31.88-2.9z"
      />
      <path
        d="M1501.3 821.6s0 32.86-.51 39.32c-.51 6.46 3.49 16.96 12.96 15.54 9.47-1.41 13.46-4.87 13.95-15.32.51-10.45-12.96-40.93-12.96-40.93l-13.46 1.38h.01Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1448.99 413.81c-51.85 13.91-60.44 191.57-67.72 235.11-7.28 43.54 3.24 109.05 12.13 133.34 8.9 24.3 15.37 25.96 15.37 25.96l14.85 25.74 49.04-22.8s-9.7-24.31-7.28-85.66c2.42-61.36-5.28-73.56-3.33-101.78 2.5-36.2 12.91-124.37 13.73-151.01.8-26.64 5.51-67.59-26.78-58.92Z"
        style={{
          fill: '#31405d',
        }}
      />
      <path
        d="m1534.39 352.01-13.85 8.78-27.18 57.63s43.97-9.66 61.66-9.66 22.84 1.47 22.84 1.47 24.33-7.37 35.37-3.69c11.06 3.69 44.22 5.16 44.22 5.16l-29.48-50.11-15.47-10.31s0 28.01-11.06 36.85-25.8 16.96-25.8 16.96-28.01-10.31-35.37-23.58c-7.37-13.27-5.9-29.48-5.9-29.48h.01Z"
        style={{
          fill: '#222d44',
        }}
      />
      <path
        style={{
          fill: '#222d44',
        }}
        d="m1444.21 411.36 7.38 13.99 55.74-29.12 1.67-16.22-14.97 2.49-49.82 28.86zM1706.63 394.15l-6.2 14.55-57.97-24.38-3.6-14.39 15.72-.4 52.05 24.62z"
      />
      <path
        d="M1577.56 265.54s5.99-1.28 12.62-1.69c6.73-.42 13.4 4.47 13.49 4.55s1.99-2.99 1.99-2.99-9.51-7.45-17.62-7.49-12.97 2.9-12.97 2.9l2.51 4.73h-.01ZM1589.57 279.34l8.01 2.3 1.03-2.67-9.33-4.21s.04 4.53.3 4.58Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        style={{
          fill: '#2f2b39',
        }}
        d="m1587.15 276.62 12.21-.19.42-2.97-12.75-.14.12 3.3z"
      />
      <path
        d="M1590.06 271.6c2.48 1.78 3.02 4.7 1.16 7.06s-4.8 2.39-7.13.94c-2.75-1.71-2.59-4.61-.92-7.22 1.17-1.84 4.34-2.6 6.9-.77Z"
        style={{
          fill: '#2f2b39',
        }}
      />
      <path
        d="M1584.41 429.06c-3.98-.18-6.26 3.14-6.43 5.53-.19 2.38.61 6.24 5.26 6.85 4.95.65 6.94-2.1 7.4-5.22.45-3.08-1.62-6.95-6.21-7.15h-.01ZM1588.66 501.54c-3.98-.18-6.26 3.14-6.43 5.53-.19 2.38.61 6.24 5.26 6.85 4.95.65 6.94-2.1 7.4-5.22s-1.62-6.95-6.21-7.15h-.01ZM1590.67 585.68c-3.98-.18-6.26 3.14-6.43 5.53-.19 2.38.61 6.24 5.26 6.85 4.95.65 6.94-2.1 7.4-5.22.45-3.08-1.62-6.95-6.21-7.15h-.01ZM1591.38 654.95c-3.98-.18-6.26 3.14-6.43 5.53-.19 2.38.61 6.24 5.26 6.85 4.95.65 6.94-2.1 7.4-5.22.45-3.08-1.62-6.95-6.21-7.15h-.01Z"
        style={{
          fill: '#222d44',
        }}
      />
    </svg>
  )
}

export default BorderPoliceEnd

